import Error from 'next/error'
import React from 'react'

import { ResultErrorGeneric } from '@/components/common/result'

type PropsType = { children: React.ReactNode | JSX.Element }
type State = { hasError: boolean }

export class ErrorBoundary extends React.Component<PropsType, State> {
  constructor(props: PropsType) {
    super(props)
    this.state = { hasError: undefined }
  }

  static getDerivedStateFromError(error: Error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: error }
  }

  render() {
    if (this.state.hasError) {
      return <ResultErrorGeneric componentId="ErrorBoundary" />
    }

    return this.props.children
  }
}
